// extracted by mini-css-extract-plugin
export default {"nopage__card":"ErrorPage_nopage__card__f3gyh","h1":"ErrorPage_h1__HkfCr","h2":"ErrorPage_h2__ds9nk","h3":"ErrorPage_h3__vviNZ","button":"ErrorPage_button__knjZP"};